import { render, staticRenderFns } from "./GamesList.vue?vue&type=template&id=cbf4a9da&scoped=true&"
import script from "./GamesList.vue?vue&type=script&lang=js&"
export * from "./GamesList.vue?vue&type=script&lang=js&"
import style0 from "./GamesList.vue?vue&type=style&index=0&id=cbf4a9da&lang=scss&scoped=true&"
import style1 from "./GamesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf4a9da",
  null
  
)

export default component.exports